<!--设备台账-->
<template>
  <div class="newarchives">
    <div class="con">

      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small ">
              <span>用户名：</span>
              <el-input v-model="userCode" clearable placeholder="请输入名称"></el-input>
            </div>
            <div class="input-small " style="margin:0px 0.2rem;">
              <span>日期：</span>
              <el-date-picker v-model="dateTimer" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            <div class="input-small">
              <span>IP地址：</span>
              <el-input v-model="IPAddress" clearable placeholder="请输入IP地址"></el-input>
            </div>
            <div class="input-small myinput" style="margin:0px 0.2rem;">
              <span>类型：</span>
              <el-select v-model="typeEnum" placeholder="请选择" clearable style="width:1.6rem">
                <el-option v-for="item in typeEnumList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput">
              <span>状态：</span>
              <el-select v-model="stateEnum" placeholder="请选择" clearable style="width:1.6rem">
                <el-option v-for="item in stateEnumList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" size="mini" plain @click="getList" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>
      </div>
      <!--  -->
      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table id="demo" :height="heights - 20" border stripe
          :data="tableData.filter(res=> !userCode || res.logType== typeEnum || res.userCode.includes(userCode)) "
          style="width: 100%">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userCode" label="用户名"> </el-table-column>
          <el-table-column prop="ipAddress" label="IP地址"> </el-table-column>
          <el-table-column prop="logType" label="类型">
            <template #default="{row}">
              {{row.logType == 'LOGIN' ? '登录' : '退出'}}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">

            <template #default="{row}">
              <div class="state-row open-state" v-if="row.state=='WIN'">
                <span></span>成功
              </div>
              <div class="state-row close-state" v-else>
                <span></span>失败
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
          </el-table-column>

        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script type="text/javascript">
  import { getUserLoginLog } from "../../api/abbNewApi";
  export default {
    components: {

    },
    props: [],
    data() {
      return {
        heights: document.getElementById('app').clientHeight - 240,
        tableData: [],
        userCode: "",
        dateTimer: null,
        currentPage: 1,
        currentSize: 15,
        total: 0,
        typeEnum: "",
        typeEnumList: [
          {
            name: '登录',
            value: 'LOGIN',
          },
          {
            name: '退出',
            value: 'EXIT',
          }
        ],
        IPAddress: "",
        stateEnum: "",
        stateEnumList: [
          {
            name: '成功',
            value: 'WIN',
          },
          {
            name: '失败',
            value: 'FAIL',
          }
        ],

        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
        },
      }
    },
    created() {

    },
    mounted() {
      this.getList()
    },
    destroyed() { },
    computed: {

    },
    methods: {
      seach_fn() { },
      getList() {
        var res = {
          "content": [
            {
              "id": 345684154585089,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721608968000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 345210146439169,
              "ipAddress": "192.168.124.151",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721377518000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 345209885118465,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721377395000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 345161309171713,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721353672000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 345156555350017,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721351351000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344812474683393,
              "ipAddress": "192.168.124.155",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721183345000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344812125339649,
              "ipAddress": "192.168.124.155",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721183175000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344809088159745,
              "ipAddress": "192.168.124.155",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721181689000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344799424045057,
              "ipAddress": "192.168.124.155",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721176970000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344693320091649,
              "ipAddress": "192.168.124.155",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721125162000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344642730549249,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721100490000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344642725873665,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721100458000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344642725699585,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721100458000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344641971990529,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "LOGIN",
              "createTime": 1721100090000,
              "state": "WIN",
              "remark": "登录成功"
            },
            {
              "id": 344641943185409,
              "ipAddress": "192.168.124.13",
              "address": "私有地址",
              "userCode": "1",
              "logType": "EXIT",
              "createTime": 1721100075000,
              "state": "WIN",
              "remark": "退出成功!"
            }
          ],
          "pageable": {
            "sort": {
              "unsorted": false,
              "sorted": true,
              "empty": false
            },
            "offset": 0,
            "pageSize": 15,
            "pageNumber": 0,
            "paged": true,
            "unpaged": false
          },
          "last": false,
          "totalPages": 148,
          "totalElements": 2216,
          "size": 15,
          "number": 0,
          "sort": {
            "unsorted": false,
            "sorted": true,
            "empty": false
          },
          "numberOfElements": 15,
          "first": true,
          "empty": false
        }
        this.tableData = res.content
        this.total = res.totalElements;
        var d = {
          "pageIndex": this.currentPage,
          "pageSize": this.currentSize,
          'IPAddress': this.IPAddress,
          'stateEnum': this.stateEnum,
          'typeEnum': this.typeEnum,
          'userCode': this.userCode
        }

        for (let key in d) {
          if (d[key] === '') {
            delete d[key];
          }
        }

        if (this.dateTimer) {
          d.startTime = this.dateTimer[0].getTime()
          d.endTime = this.dateTimer[1].getTime()
        }

      },

      //分页功能 
      handleSizeChange(val) {
        this.currentSize = val;
        this.getList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList()
      }

    },
    filters: {

      // 转换时间戳
      date_format(value) { //value就是插值的数据
        if (!value) {
          return ""
        }
        let date = new Date(value);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        let strDate = Y + M + D + h + m + s;
        return strDate
      },
    }
  }
</script>
<style scoped lang="scss">
  .newarchives {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 12px 20px;
      padding-top: 2px;
      //  display: flex;
      background-color: #fff;

      .search-input-btn {
        width: 100%;
        height: 36px;

        .my-search-i {
          width: 100%;
          display: flex;
          align-items: center;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .state-row {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          margin-right: 10px;
          position: relative;
          top: -1px;
          border: 3px solid transparent;
        }
      }

      .open-state {
        color: #0DAE88;

        span {
          background-color: #0DAE88;
          border-color: #B0FFED;
        }
      }

      .close-state {
        color: #FF1D1D;

        span {
          background-color: #FF1D1D;
          border-color: #FFD7D7;
        }
      }

    }
  }
</style>